/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Guest_CapacityInputs */

const en_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest Capacity`)
};

const es_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad de invitados`)
};

const fr_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité des invités`)
};

const de_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gästekapazität`)
};

const ja_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲスト収容人数`)
};

const zh_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`载客量`)
};

const ar_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سعة الضيوف`)
};

const id_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapasitas Tamu`)
};

const it_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capienza Ospiti`)
};

const ru_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вместимость гостей`)
};

const pt_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidade de Convidados`)
};

const ko_field_guest_capacity = /** @type {(inputs: Field_Guest_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승선 가능 인원`)
};

/**
* | output |
* | --- |
* | "Guest Capacity" |
*
* @param {Field_Guest_CapacityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_guest_capacity = /** @type {((inputs?: Field_Guest_CapacityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Guest_CapacityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_guest_capacity(inputs)
	if (locale === "es") return es_field_guest_capacity(inputs)
	if (locale === "fr") return fr_field_guest_capacity(inputs)
	if (locale === "de") return de_field_guest_capacity(inputs)
	if (locale === "ja") return ja_field_guest_capacity(inputs)
	if (locale === "zh") return zh_field_guest_capacity(inputs)
	if (locale === "ar") return ar_field_guest_capacity(inputs)
	if (locale === "id") return id_field_guest_capacity(inputs)
	if (locale === "it") return it_field_guest_capacity(inputs)
	if (locale === "ru") return ru_field_guest_capacity(inputs)
	if (locale === "pt") return pt_field_guest_capacity(inputs)
	return ko_field_guest_capacity(inputs)
});